import { errorColor } from 'root/src/client/web/commonStyles'

// eslint-disable-next-line import/prefer-default-export
export const errorStyle = {
	display: 'flex',
	color: `${errorColor} !important`,
	fontSize: 12,
	border: '1px solid #e02020',
	justifyContent: 'center',
	alignItems: 'center',
	marginTop: -1,
	padding: 3,
}
